exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".images-slider__image[data-v-709c8966]{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;float:left;border-radius:5px;background-color:#f5f5fa;box-shadow:0 0 5px 0 rgba(0,0,0,.1);margin:20px;position:relative}.images-slider__image--not-draggable .images-slider__image__price[data-v-709c8966]{background-color:#ff5454}.images-slider__image__price[data-v-709c8966]{position:absolute;right:-30px;top:-20px;height:70px;width:70px;border-radius:70px;background-color:#63bf3f;color:#fff;line-height:70px;text-align:center;font-size:18px}.images-slider__image img[data-v-709c8966]{height:170px;width:170px}.images-slider__image img[draggable=false][data-v-709c8966]{pointer-events:none;opacity:.2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-709c8966","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./assets/vue/apps/participate/playset-image.vue
// module id = 355
// module chunks = 0 1